import { useTranslation } from "react-i18next";

const STEPS = [
  { number: "01", key: "how_it_works_step_1" },
  { number: "02", key: "how_it_works_step_2" },
  { number: "03", key: "how_it_works_step_3" },
] as const;

const Arrow = () => (
  <span
    className="hidden md:flex items-center justify-center shrink-0 text-gray-500 px-2 lg:px-4"
    aria-hidden
  >
    <svg
      width="28"
      height="16"
      viewBox="0 0 28 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8H26M26 8L19 1M26 8L19 15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const HowItWorks = () => {
  const { t } = useTranslation();

  return (
    <section
      className="w-full bg-home px-4 xl:px-6 2xl:px-8 pt-6 sm:pt-8 pb-14 sm:pb-20"
      aria-labelledby="how-it-works-heading"
    >
      <div className="mx-auto max-w-[1800px]">
        <header className="mb-12 sm:mb-16 max-w-2xl">
          <h2
            id="how-it-works-heading"
            className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight"
            style={{ fontFamily: '"Object Sans", system-ui, sans-serif' }}
          >
            {t("how_it_works_title")}
          </h2>
          <p className="mt-3 sm:mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
            {t("how_it_works_subtitle")}
          </p>
        </header>

        <ol className="flex flex-col md:flex-row md:items-start gap-8 md:gap-0 list-none m-0 p-0">
          {STEPS.map((step, index) => (
            <li
              key={step.number}
              className="flex flex-1 md:items-start gap-4 md:gap-0"
            >
              <div className="flex-1 min-w-0">
                <span
                  className="block text-5xl sm:text-6xl lg:text-7xl font-bold text-darkBlue leading-none tracking-tight"
                  style={{ fontFamily: '"Object Sans", system-ui, sans-serif' }}
                >
                  {step.number}
                </span>
                <p className="mt-3 sm:mt-4 text-base sm:text-lg font-medium text-gray-900 leading-snug max-w-[280px]">
                  {t(step.key)}
                </p>
              </div>
              {index < STEPS.length - 1 && <Arrow />}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowItWorks;
